// @flow
import React from 'react';
import { useFormikContext } from 'formik';

import {
  AUG_1_RATE_CARD_VERSION,
  DEAL_TYPE_BACKEND_NAME,
  DEAL_TYPE_RENEWAL,
  GLOBAL_DISCOUNT_APPLIED_BACKEND_NAME,
  RATE_CARD_BACKEND_NAME,
} from '../../constants';
import {
  getLatestActionableRateCardName,
  useEstimateRateCards,
} from '../../custom-hooks/useEstimateRateCards';
import { If } from '../presentational/If';
import { WarningMessageContainer } from '../presentational/messages/WarningMessageContainer';

const RATE_CARD_POLICY_LINK =
  'https://confluentinc.atlassian.net/wiki/spaces/PM/pages/2182939664/Confluent+Cloud+Rate+Card+Policy/';

export const RenewalWarningContainer = () => {
  const { values, errors } = useFormikContext();
  const rateCards = useEstimateRateCards();

  const isRenewal = values[DEAL_TYPE_BACKEND_NAME] === DEAL_TYPE_RENEWAL;
  if (!isRenewal) {
    return null;
  }

  const hasGlobalDiscountError = Boolean(errors[GLOBAL_DISCOUNT_APPLIED_BACKEND_NAME]);
  if (hasGlobalDiscountError) {
    return null;
  }

  const selectedRateCard = values[RATE_CARD_BACKEND_NAME];
  const latestRC = getLatestActionableRateCardName(rateCards);

  const show81RateCardChangeWarning = selectedRateCard === AUG_1_RATE_CARD_VERSION;
  const showLatestRateCardWarning = selectedRateCard === latestRC;

  return (
    <>
      <If test={show81RateCardChangeWarning}>
        <WarningMessageContainer
          link={RATE_CARD_POLICY_LINK}
          message="Rate card change at renewal. Check renewal policy!"
        />
      </If>
      <If test={showLatestRateCardWarning}>
        <WarningMessageContainer
          link={RATE_CARD_POLICY_LINK}
          message="Latest Rate card used for Renewal. Check renewal policy!"
        />
      </If>
    </>
  );
};
